import { gql } from '@apollo/client';

export const CREATE_TMS_SCHEDULE = gql`
    mutation CreateTmsSchedule($input: CreateTmsScheduleInput!) {
        createTmsSchedule(input: $input) {
            id
            scheduleName
            routeId
            warehouseId
            planDepartureTime
            planArrivalTime
            arrivalDayOffset
            departureDayOffset
            departureFrequency
            carrierId
            driverId
            vehicleId
            vehicleTypeId
            status
            createdAt
            updatedAt
        }
    }
`;

export const UPDATE_TMS_SCHEDULE = gql`
    mutation UpdateTmsSchedule($id: ID!, $input: UpdateTmsScheduleInput!) {
        updateTmsSchedule(id: $id, input: $input) {
            id
            scheduleName
            routeId
            warehouseId
            planDepartureTime
            planArrivalTime
            arrivalDayOffset
            departureDayOffset
            departureFrequency
            carrierId
            driverId
            vehicleId
            vehicleTypeId
            status
            createdAt
            updatedAt
        }
    }
`;

export const UPDATE_TMS_SCHEDULE_WITH_WAYPOINTS = gql`
    mutation UpdateTmsScheduleWithWaypoints($id: ID!, $input: UpdateTmsScheduleWithWaypointsInput!) {
        updateTmsScheduleWithWaypoints(id: $id, input: $input) {
            id
            scheduleName
            scheduleType
            startWarehouseId
            endWarehouseId
            plannedTotalHours
            plannedTotalMiles
            carrierId
            status
            createdAt
            updatedAt
        }
    }
`;

export const DELETE_TMS_SCHEDULE = gql`
    mutation DeleteTmsSchedule($id: ID!) {
        deleteTmsSchedule(id: $id)
    }
`;

export interface CreateTmsScheduleInput {
    scheduleName: string;
    routeId: number;
    warehouseId: number;
    planDepartureTime: string;
    planArrivalTime: string | null;
    arrivalDayOffset: number | null;
    departureDayOffset: number;
    departureFrequency: string;
    carrierId: number;
    driverId: number | null;
    vehicleId?: number | null;
    vehicleTypeId?: number | null;
    status: number;
}

export interface UpdateTmsScheduleInput {
    scheduleName?: string;
    routeId?: number;
    warehouseId: number;
    planDepartureTime?: string;
    planArrivalTime?: string;
    arrivalDayOffset?: number;
    departureFrequency?: string;
    carrierId?: number;
    driverId?: number | null;
    vehicleId?: number | null;
    vehicleTypeId?: number | null;
    status?: number;
}

export interface ScheduleWaypointInput {
    waypointId: number;
    waypointOrder: number;
    waypointType: number;
    waypointStatus?: number;
    travelTime?: number;
    dwellTime?: number;
    distance?: number;
}

export interface UpdateTmsScheduleWithWaypointsInput {
    scheduleType: number;
    carrierId: number;
    status: number;
    startWarehouseId: number;
    endWarehouseId: number | null;
    plannedTotalHours?: number;
    plannedTotalMiles?: number;
    waypoints: ScheduleWaypointInput[];
}

export interface CreateTmsScheduleResponse {
    createTmsSchedule: {
        id: string;
        scheduleName: string;
        scheduleType: number;
        startWarehouseId: number;
        endWarehouseId: number | null;
        plannedTotalHours: number;
        plannedTotalMiles: number;
        carrierId: number;
        status: number;
        createdAt: string;
        updatedAt: string;
    };
}

export interface UpdateTmsScheduleResponse {
    updateTmsSchedule: {
        id: string;
        scheduleName: string;
        routeId: number;
        planDepartureTime: string;
        departureFrequency: string;
        carrierId: number;
        driverId: number;
        vehicleId?: number | null;
        vehicleTypeId?: number | null;
        status: number;
        createdAt: string;
        updatedAt: string;
    };
}

export interface UpdateTmsScheduleWithWaypointsResponse {
    updateTmsScheduleWithWaypoints: {
        id: string;
        scheduleName: string;
        scheduleType: number;
        startWarehouseId: number;
        endWarehouseId: number | null;
        plannedTotalHours: number;
        plannedTotalMiles: number;
        carrierId: number;
        status: number;
        createdAt: string;
        updatedAt: string;
    };
}

